import { useEffect, useState } from 'react';
import EventBus from '../../utilities/EventBus';
import SystemMessageDialog from './SystemMessageDialog'; // You'll build this next

const SystemMessageWatcher = () => {
  const [open, setOpen] = useState(false);
  const [flags, setFlags] = useState({});

  useEffect(() => {
    const handleShow = (data) => {
      setFlags(data);
      setOpen(true);
    };

    EventBus.on('SHOW_SYSTEM_MESSAGE', handleShow);
    return () => EventBus.off('SHOW_SYSTEM_MESSAGE', handleShow);
  }, []);

  return (
    <>
      {open && (
        <SystemMessageDialog
          open={open}
          flags={flags}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default SystemMessageWatcher;